export const ONE_HOUR = 60 * 60
export const ONE_DAY = 60 * 60 * 24
export const ONE_WEEK = 60 * 60 * 24 * 7
export const ONE_MONTH = 60 * 60 * 24 * 30
export const ONE_YEAR = 60 * 60 * 24 * 365
